import { setupDocumentReady } from './document-ready.ts';
import { setupLazyLoad } from './lazy-load.ts';

export function setup(): void {
  setupLazyLoad();
  setupDocumentReady();
}
